import React from 'react';
import moment from 'moment';
import NoDataMsg from 'library/noData';
const Body = ({ giftCardBalance = {}, branchOptions, endDate, beginDate }) => {
    return(<React.Fragment>
        {giftCardBalance.list.length <= 0 ?
            //If there's NO DATA to display
            <NoDataMsg />
                :
            //     //If there's DATA
            <React.Fragment>
                <div className="row m-0">
                    <div className="text-center list_header">
                        {beginDate ?
                            <p>{endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                            : ""}
                    </div>
                </div>
                <div className="table-responsive">
                    {
                        giftCardBalance.list.map((item, index) => {
                            const { balance, branchId, cardNumber, createdDate, employeeName, id, refundDate, type } = item || {};
                            const branchName = branchOptions.length > 0 && branchOptions.find(item => item.value === `${branchId}`) ? branchOptions.find(item => item.value === `${branchId}`).text : ``;
                            const typeText = type === 1 ? `Sale` : type === 2 ? `Refund` : ``;
                            return (
                                <div className="row m-0 border_bottom_grey pt-2 pb-2 price_info col-4-padding" key={index}>
                                    <div className="col-lg-1 col-md-2 col-sm-4 col-xs-4 col-md- m-0 p-0">
                                        <h6>Id</h6>
                                        <span>{id}</span>
                                    </div>
                                    <div className="col-lg-1 col-md-3 col-sm-4 col-xs-4 col-md- m-0 p-0">
                                        <h6>Branch</h6>
                                        <span>{!branchId ? "n/a" : branchName}</span>
                                    </div>
                                    <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12 m-0 p-0">
                                        <h6>Employee</h6>
                                        <span>{!employeeName ? "n/a" : employeeName}</span>
                                    </div>
                                    <div className="col-lg-1 col-md-2 col-sm-4 col-xs-4 col-md- m-0 p-0">
                                        <h6>Type</h6>
                                        <span>{typeText}</span>
                                    </div>
                                    <div className="col-lg-2 col-md-2 col-sm-4 col-xs-4 col-md- m-0 p-0">
                                        <h6>Card Number</h6>
                                        <span>{cardNumber == null ? "n/a" : cardNumber}</span>
                                    </div>
                                    <div className="col-lg-1 col-md-2 col-sm-4 col-xs-4 col-md- m-0 p-0">
                                        <h6>Balance</h6>
                                        <h3 className="green-text mt-0">{balance == null ? "n/a" : balance}</h3>
                                    </div>
                                    <div className="col-lg-2 col-md-4 col-sm-4 col-xs-4 col-md- m-0 p-0">
                                        <h6>Created Date</h6>
                                        <span>{moment(createdDate).format('MMMM Do, YYYY')}</span>
                                    </div>
                                    <div className="col-lg-2 col-md-4 col-sm-4 col-xs-4 col-md- m-0 p-0">
                                        <h6>Refund Date</h6>
                                        <span>{!refundDate ? "n/a" : moment(refundDate).format('MMMM Do, YYYY')}</span>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </React.Fragment>
        }
    </React.Fragment>
    );
}
export default Body;